import EMVERSITY from "@/assets/industry-co-led/partners/EMVERSITY.png";
import Icon1 from "@/assets/industry-co-led/logo/madel.png";
import Icon2 from "@/assets/industry-co-led/logo/network.png";

import Student1 from "@/assets/students/student1.png";
import Student2 from "@/assets/students/student2.png";
import Student3 from "@/assets/students/student3.png";
import Student4 from "@/assets/students/student4.png";

const OJLImg1 = "https://cdn.msu.edu.in/msu_emergency_medical_tech1_25e05f6f9c.webp";
const OJLImg2 = "https://cdn.msu.edu.in/Diya_Gurung_f9242ab1bb.webp";
const OJLImg3 = "https://cdn.msu.edu.in/Mingma_8855f3c71a.webp";
const OJLImg4 = "https://cdn.msu.edu.in/OJT_Image_6598594b5d.webp";
const OJLImg5 = "https://cdn.msu.edu.in/Sudip_Subba_bb2d4992c0.webp";
const OJLImg6 = "https://cdn.msu.edu.in/SOVA_2c9091689a.webp";

const Img1 = "https://cdn.msu.edu.in/art_1_5f4d03990e.webp";
const Img2 = "https://cdn.msu.edu.in/EMT_9cdd1dfe2e.webp";
const Img3 = "https://cdn.msu.edu.in/emergency_medical_technology_5a1a2eb660.webp";
const Img4 = "https://cdn.msu.edu.in/EMT_4_3d66f2cd55_13b98b3792.png";
const Img5 = "https://img.youtube.com/vi/lTWke3-IGz4/hqdefault.jpg";

export const bemtData = {


    heroSection: {
        breadcrumb: [
            { name: "Home", url: "/" },
            { name: "Industry Co-led UG Programmes", url: "/industry-co-led-ug-programmes" },
            { name: "Bachelors of Emergency Medical Technologist (Paramedic)", url: "" }
        ],
        bannerImg: '/assets/industry-co-led-banner.png',
        title: "Bachelors of Emergency Medical Technologist (Paramedic)",
        poweredBy: {
            text: "Industry Skilling Partner",
            logo: EMVERSITY
        },
        duration: "4 Year Undergraduate Degree Programme",
        description:
            "Learn about Advanced Life Support, Trauma Assessment & Management, Airway Management & Ventilation, Cardiac Emergencies & ACLS, Mass Casualty & Disaster Management and more in the healthcare sector.",

        stats: [
            {
                value: "Up to 70%",
                label: "Practical Curriculum"
            },
            {
                value: "Paid",
                label: "On-the-job learning"
            },
            {
                value: "100%",
                label: "Placement assistance"
            }
        ],

        buttons: {
            download: "Download Brochure",
            enroll: "Enroll Now"
        },

        video: {
            thumbnail: 'https://img.youtube.com/vi/ZWXM0DnVOCc/hqdefault.jpg',
            buttonText: "Watch Programme Video",
            url: "https://www.youtube.com/embed/ZWXM0DnVOCc"
        }
    },

    aboutSection: {
        tag: "ABOUT THE PROGRAMME",
        title: "A Degree Built for High-Stakes Emergency Care",
        description: [
            "The Bachelors of Emergency Medical Technologist (Paramedic) prepares students to respond effectively in critical, time-sensitive medical situations. The program combines biomedical foundations with hands-on training in trauma care, advanced life support and emergency response.",
            "Through simulation-based learning, clinical training, and hospital internships, students develop the technical skills and on-ground confidence required in emergency departments, ambulance services and disaster scenarios. Graduates are equipped to deliver fast, accurate and life-saving care when it matters most."
        ],
        stats: [
            { value: "Up to 70%", label: "Practical Curriculum" },
            { value: "Paid", label: "On-the-job learning" },
            { value: "100%", label: "Placement assistance" }
        ],
        approvals: [
            "UGC Approved",
            "NEP 2020 Aligned",
            "Scholarships Available"
        ],
        journeyTitle: "Your 4-Year Journey",
        journey: [
            {
                "phase": "YEAR 1",
                "title": "Biomedical Foundations",
                "description": "Human anatomy, physiology, basic nursing and introduction to emergency medicine"
            },
            {
                "phase": "YEAR 2",
                "title": "Core Emergency Sciences",
                "description": "Triage, patient assessment, airway management and emergency pharmacology"
            },
            {
                "phase": "YEAR 3",
                "title": "Advanced Trauma & Critical Care",
                "description": "Cardiac, neurological, paediatric, and disaster management with clinical rotations"
            },
            {
                "phase": "YEAR 4",
                "title": "Clinical Practice & Professional Readiness",
                "description": "Advanced trauma protocols, hospital operations, internships, and research project"
            },
            {
                "phase": "GRADUATE",
                "title": "Bachelors of Emergency Medical Technologist (Paramedic)",
                "description": "Industry-ready emergency care professional"
            }
        ]
    },

    offeringSection: {
        tag: "OUR OFFERING",
        title: {
            first: "Comprehensive",
            highlight: "Emergency Care Education"
        },
        description:
            "We offer a UGC-recognised, full-time undergraduate degree, Bachelors of Emergency Medical Technologist (Paramedic) at Medhavi Skills University, Sikkim. It is an industry-aligned allied healthcare program designed to build strong clinical skills and prepare students for high-impact roles in emergency and trauma care.",
        learningBox: {
            title: "Key Areas of Learning",
            points: [
                "Biochemistry",
                "Microbiology",
                "Patient Care and Assessment",
                "Surgical Emergencies",
                "Neonatology and Pediatrics",
                "Emergency Clinical Procedures"
            ]
        },
        image: 'https://cdn.msu.edu.in/large_emergency_medical_technology_msu_1_a339b91abe.webp'
    },

    whyEMT: {
        tag: "WHY EMERGENCY MEDICAL TECHNOLOGY. WHY NOW.",
        title: "The Critical Pulse of India's Healthcare Revolution",
        description:
            "Our curriculum is engineered for the urgent demands of India's evolving emergency landscape. As the nation prioritizes rapid trauma response, the Paramedic has evolved from a support role into a frontline life-saving necessity.",
        stats: [
            {
                value: "$1.36 Billion",
                text: "Valuation of the Indian EMS Market. With the sector projected to hit $2 billion by 2034, massive investment in Advanced Life Support (ALS) fleets has created an urgent need for technologists capable of managing high-pressure, mobile critical care environments.",
            },
            {
                value: "500,000+",
                text: "Estimated Shortfall of Trained Paramedics. India currently operates far below the WHO-recommended ambulance-to-population ratio. To support nationwide trauma initiatives and the expansion of emergency networks, the demand for certified EMTs now far outstrips the talent pool.",
            },
            {
                value: "60 Minutes",
                text: "The \"Golden Hour\" Mandate. Access to care within the first hour of injury is now recognized as a Constitutional Right in India. This shift compels hospitals to hire specialists who can provide definitive stabilization and advanced life support before the patient ever reaches the ER.",
            },
        ],
    },

    msuAdvantages: {
        tag: "MSU ADVANTAGES",
        title: "Programme by Emversity, Delivered at MSU Campus",
        description:
            "Where academic excellence meets the operational demands of the modern allied and healthcare industry.",
        cards: [
            {
                number: "01",
                text: "Only university in Sikkim aligned with paid On-the-Job Learning embedded curriculum for practical learning.",
            },
            {
                number: "02",
                text: "Only university in Sikkim to ensure 100% of our student applicants receive government scholarships.",
            },
            {
                number: "03",
                text: "Well-equipped simulation labs, advanced training setups and hands-on field training.",
            },
        ],
        pointerTitle: "Highlights from The Programme:",
        highlights: [
            "Programme aligned with NEP2020, focused in Learning Outcome Based Education",
            "Up to 70% practical based curriculum",
            "Paid On-the-job Learning",
            "Industry-aligned curriculum & hands-on learning",
            "Learn from seasoned professionals",
            "Immersive industry exposure through industry visits, guest lectures and networking opportunities",
            "Chance to 'learn and earn' through immersive on-the-job learning, industry projects and internships with leading companies",
            "Engage with industry experts to get invaluable insights and real-world perspectives"
        ],
        image: 'https://cdn.msu.edu.in/advantages_0d90859efe.webp',
    },

    CTA: {
        title: "Start Your Journey in Emergency Care with Emversity's",
        highlights: "Bachelors of Emergency Medical Technologist (Paramedic)",
        url: "#",
        btnName: "Apply Now"
    },

    onJobtrainningData: {
        tag: "ON-THE-JOB LEARNING",
        title: "Practical Industry Exposure",
        description: "Our On-the-job Learning (OJL) enables students to gain real industry experience and earn a stipend while you gain your degree.",
        images: [
            { "id": 1, "src": OJLImg1, "alt": "Pranita Pradhan for On-Job Training at CRH Manipal, Gangtok" },
            { "id": 2, "src": OJLImg2, "alt": "Diya Gurung for On-Job-Training at Kasturi Diagnostic, Namchi" },
            { "id": 3, "src": OJLImg3, "alt": "Mingma Topden Bhutia for On-Job-Training at Kasturi Diagnostic, Namchi" },
            { "id": 4, "src": OJLImg4, "alt": "Sonika Chettri for On-Job Training at District Hospital, Singtam" },
            { "id": 5, "src": OJLImg5, "alt": "Sudip Subba for On-Job Training at STNM, Gangtok" },
            { "id": 6, "src": OJLImg6, "alt": "Sova Pradhan for On-Job Training at Ruchi Diagnostic, Gangtok" }
        ]
    },

    addtionSkill: {
        "courseSections": {
            "AdditionalSkills": {
                "tag": "BONUS CREDENTIALS",
                "title": "Additional Skill Development",
                "description": "Students will have the opportunity to build additional skills that set them apart in the competitive healthcare market. These credentials, earned alongside your degree, validate your technical expertise, boost your professional credibility, and ensure you are ready for employment with leading national and international healthcare providers.",
                "image": {
                    "url": 'https://cdn.msu.edu.in/small_DSC_00373_1_532a10af8b.jpg',
                    "alternativeText": "Skill Certification"
                },
                "items": [
                    { "id": 1, "text": "Cambridge English for Healthcare Professionals as per CEFR Standards", "icon": Icon1 },
                    { "id": 2, "text": "Advanced Life Support & Emergency Response Training (BLS, ALS, ATLS Principles)", "icon": Icon2 },
                    { "id": 3, "text": "Nationally & Globally Recognised", "icon": Icon1 }
                ],
                "button": { "text": "Apply Now", "link": "/apply" }
            }
        }
    },

    DoExperienceLearndata: {
        tag: "INFRASTRUCTURE",
        title: "Do-Experience-Learn",
        description: "Discover the advantage of MSU's cutting-edge infrastructure, featuring modern laboratories, classrooms and industry-relevant facilities.",
        images: [
            { id: 1, src: Img1, size: "large", alt: "Health Labs" },
            { id: 2, src: Img2, size: "large", alt: "Emergency Units" },
            { id: 3, src: Img3, size: "small", alt: "Critical Care Units" },
            { id: 4, src: Img4, size: "small", alt: "Microbiology Labs" },
            { id: 5, src: Img5, size: "small", alt: "Virtual Campus Tour" },
        ],
    },

    studentStoriesData: {
        title: "Medhavian Speak",
        subText: "Real journeys of action and achievement.",
        students: [
            { name: "Radhika Chettri", image: Student2, videLink: "https://cdn.msu.edu.in/Student-Testimonials/Allied-Healthcare-Long.mp4", shortUrl: "https://cdn.msu.edu.in/Student-Testimonials/Allied-Healthcare-short.mp4" },
            { name: "Pratik Chettri", image: Student3, videLink: "https://cdn.msu.edu.in/Student-Testimonials/Computer-Science-Long.mp4", shortUrl: "https://cdn.msu.edu.in/Student-Testimonials/Computer-Science+-short.mp4" },
            { name: "Suhana Sharma", image: Student4, videLink: "https://cdn.msu.edu.in/Student-Testimonials/Pharmacy-Long.mp4", shortUrl: "https://cdn.msu.edu.in/Student-Testimonials/Pharmacy-short.mp4" },
            { name: "Hissey Bhutia", image: Student1, videLink: "https://cdn.msu.edu.in/Student-Testimonials/Nursing-Long.mp4", shortUrl: "https://cdn.msu.edu.in/Student-Testimonials/Nursing-short.mp4" },
        ],
    },

    eligibility: {
        tag: "ELIGIBILITY",
        title: "Who Can Apply?",
        description: "10+2 (Any Stream) with 50% Aggregate with Physics, Chemistry and Biology/Mathematics as core subjects.",
        button: { text: 'Apply Now', url: "" },
        items: [
            {
                title: "12th Pass - Any Stream",
                text: "Candidates from any stream with Physics, Chemistry and Biology/Mathematics as core subjects are eligible to apply for the programme.",
            },
        ],
    },

    careerProspects: {
        "tag": "CAREER PROSPECTS",
        "heading": "Career Prospects",
        "description": "The Bachelors of Emergency Medical Technologist (Paramedic) opens doors to critical, frontline roles across hospitals, emergency response systems, and disaster management services.",
        "roles": [
            "Emergency Medical Technologist (EMT) / Paramedic",
            "Trauma Care Specialist / Emergency Department Technician",
            "Pre-Hospital Care Coordinator / Ambulance Services Executive",
            "Critical Care Technologist / ICU Support Specialist",
            "Disaster Management & Emergency Response Officer",
            "Industrial Safety & Emergency Response Executive",
            "Event Medical Services Professional",
            "Healthcare Emergency Operations Coordinator"
        ]
    },

    curriculumStructure: {
        "label": "What You Will Learn",
        "heading": "Curriculum Structure",
        "description": "The curriculum blends strong biomedical foundations with intensive clinical training and industry-integrated modules, ensuring students gain real-world emergency care experience throughout their degree.",
        "semesters": [
            {
                "name": "Semester 1",
                "title": "Building Foundations in Emergency Medical Care and Patient Response",
                "description": "The first semester introduces students to the fundamental sciences and operational principles that form the backbone of emergency medical services. Through the study of anatomy, physiology, and biochemistry, learners develop an understanding of the human body and its functions. The curriculum also provides an introduction to emergency medical services, ambulance operations, communication techniques, and essential digital skills, laying the groundwork for effective patient care, emergency response, and professional practice in pre-hospital healthcare settings.",
                "subjects": [
                    { "name": "Anatomy", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" },
                    { "name": "Physiology", "bgColor": "bg-[#FFE5CC]", "textColor": "text-[#CC6600]" },
                    { "name": "Biochemistry", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" },
                    { "name": "Introduction to EMS and Ambulance Operation", "bgColor": "bg-[#E8D5FF]", "textColor": "text-[#6B00CC]" },
                    { "name": "Communication Skills", "bgColor": "bg-[#FFD5D5]", "textColor": "text-[#CC0000]" },
                    { "name": "Basics of Computers", "bgColor": "bg-[#D5F0FF]", "textColor": "text-[#006699]" }
                ]
            },
            {
                "name": "Semester 2",
                "title": "Strengthening Clinical Knowledge for Emergency Response",
                "description": "The second semester expands students' understanding of disease processes, medications, and patient care considerations essential in emergency medical services. Through the study of pathology, microbiology, and pharmacology, learners gain insights into the causes, progression, and management of various health conditions. The curriculum also introduces emergency medical instrumentation, community medicine, and psychology, helping students develop the technical knowledge, situational awareness, and interpersonal skills required to support effective patient assessment and emergency interventions.",
                "subjects": [
                    { "name": "Pharmacology", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" },
                    { "name": "Pathology", "bgColor": "bg-[#FFE5CC]", "textColor": "text-[#CC6600]" },
                    { "name": "Microbiology", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" },
                    { "name": "Instrumentation of EM Part-I", "bgColor": "bg-[#E8D5FF]", "textColor": "text-[#6B00CC]" },
                    { "name": "Community Medicine", "bgColor": "bg-[#FFD5D5]", "textColor": "text-[#CC0000]" },
                    { "name": "Psychology", "bgColor": "bg-[#D5F0FF]", "textColor": "text-[#006699]" }
                ]
            },
            {
                "name": "Semester 3",
                "title": "Developing Competence in Emergency Assessment and Critical Care Response",
                "description": "The third semester focuses on building the clinical knowledge and practical skills required to assess, manage, and respond to a wide range of medical and trauma emergencies. Students gain an understanding of patient assessment techniques, emergency care protocols, and the management of respiratory, cardiovascular, neurological, gastrointestinal, and genitourinary emergencies. The curriculum also introduces trauma care principles, advanced emergency medical equipment, and clinical communication skills, helping learners strengthen their decision-making abilities and preparedness for real-world emergency situations.",
                "subjects": [
                    { "name": "Introduction to Patient Care and Assessment", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" },
                    { "name": "Medical Emergencies Part-I: Respiratory, Cardiovascular, Neurological, Gastrointestinal and Genitourinary", "bgColor": "bg-[#FFE5CC]", "textColor": "text-[#CC6600]" },
                    { "name": "Trauma Emergencies Part-I: Introduction to Trauma, Hemorrhage and Shock, Head and Facial Trauma, Thoracic and Abdominal Trauma", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" },
                    { "name": "Instrumentation Part-II", "bgColor": "bg-[#E8D5FF]", "textColor": "text-[#6B00CC]" },
                    { "name": "Indian Culture, Heritage, Yoga & Meditation", "bgColor": "bg-[#FFD5D5]", "textColor": "text-[#CC0000]" },
                    { "name": "Soft Skills and Clinical Communication Skills", "bgColor": "bg-[#D5F0FF]", "textColor": "text-[#006699]" },
                    { "name": "Clinical Rotation 1", "bgColor": "bg-[#FFF3CC]", "textColor": "text-[#996600]" }
                ]
            },
            {
                "name": "Semester 4",
                "title": "Advancing Emergency Care and Trauma Management Skills",
                "description": "The fourth semester deepens students' understanding of complex medical, trauma, and surgical emergencies commonly encountered in emergency healthcare settings. Learners explore the assessment and management of endocrine, hematological, immunological, oncological, psychiatric, and pulmonary emergencies while developing competencies in trauma care for musculoskeletal, spinal, and geriatric patients. The curriculum also introduces burn management, healthcare leadership, and emerging technologies such as artificial intelligence in healthcare, enabling students to strengthen their clinical judgment, adaptability, and readiness for high-pressure emergency care environments.",
                "subjects": [
                    { "name": "Medical Emergencies Part-II: Pulmonology, Endocrine, Hematology, Immunological, Oncology, Psychiatry", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" },
                    { "name": "Trauma Emergencies Part-II: Musculoskeletal Trauma, Spinal Trauma and Geriatric Trauma", "bgColor": "bg-[#FFE5CC]", "textColor": "text-[#CC6600]" },
                    { "name": "Burns", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" },
                    { "name": "Surgical Emergencies", "bgColor": "bg-[#E8D5FF]", "textColor": "text-[#6B00CC]" },
                    { "name": "Introduction and Application of Artificial Intelligence in Healthcare", "bgColor": "bg-[#FFD5D5]", "textColor": "text-[#CC0000]" },
                    { "name": "Healthcare Management: Personality Development, Leadership, Human Rights", "bgColor": "bg-[#D5F0FF]", "textColor": "text-[#006699]" },
                    { "name": "Clinical Rotation 2", "bgColor": "bg-[#FFF3CC]", "textColor": "text-[#996600]" }
                ]
            },
            {
                "name": "Semester 5",
                "title": "Expanding Expertise in Specialized and Critical Emergency Care",
                "description": "The fifth semester introduces students to specialized emergency scenarios involving toxicological, environmental, obstetric, pediatric, and neonatal care. Learners develop a deeper understanding of emergency medications, radiological investigations, and diagnostic interpretation that support timely clinical decision-making. The curriculum also explores the growing role of telemedicine in healthcare delivery, enabling students to adapt to evolving models of emergency care. Through continued clinical exposure, students strengthen their ability to assess, prioritize, and respond effectively to diverse and high-acuity patient situations.",
                "subjects": [
                    { "name": "Toxicology and Environmental Emergencies", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" },
                    { "name": "Gynecological and Obstetric Emergencies", "bgColor": "bg-[#FFE5CC]", "textColor": "text-[#CC6600]" },
                    { "name": "Neonatology and Pediatrics", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" },
                    { "name": "Clinical Pharmacology Emergency Medications", "bgColor": "bg-[#E8D5FF]", "textColor": "text-[#6B00CC]" },
                    { "name": "Basics of Radiology & Imaging Interpretation", "bgColor": "bg-[#FFD5D5]", "textColor": "text-[#CC0000]" },
                    { "name": "Telemedicine", "bgColor": "bg-[#D5F0FF]", "textColor": "text-[#006699]" },
                    { "name": "Clinical Rotation 3", "bgColor": "bg-[#FFF3CC]", "textColor": "text-[#996600]" }
                ]
            },
            {
                "name": "Semester 6",
                "title": "Mastering Critical Care, Disaster Response and Emergency Interventions",
                "description": "The sixth semester prepares students to manage complex emergencies and critical care situations through advanced clinical training and practical application. Learners gain insights into disaster preparedness, mass casualty incident management, intensive care principles, and emergency clinical procedures that are essential in high-acuity healthcare environments. The curriculum also introduces research methodology, biostatistics, and entrepreneurship, enabling students to develop analytical thinking, innovation, and leadership capabilities. Through continued clinical rotations, students strengthen their readiness to respond effectively in dynamic and demanding emergency care settings.",
                "subjects": [
                    { "name": "Disaster and MCI Management", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" },
                    { "name": "Research Methodology and Biostatistics", "bgColor": "bg-[#FFE5CC]", "textColor": "text-[#CC6600]" },
                    { "name": "Intensive Care Concepts and Management", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" },
                    { "name": "Intensive Care Concepts and Management – Practical", "bgColor": "bg-[#E8D5FF]", "textColor": "text-[#6B00CC]" },
                    { "name": "Emergency Clinical Procedures", "bgColor": "bg-[#FFD5D5]", "textColor": "text-[#CC0000]" },
                    { "name": "Business Entrepreneurship Development", "bgColor": "bg-[#D5F0FF]", "textColor": "text-[#006699]" },
                    { "name": "Clinical Rotation 4", "bgColor": "bg-[#FFF3CC]", "textColor": "text-[#996600]" }
                ]
            },
            {
                "name": "Semester 7 & 8",
                "title": "Transitioning to Professional Emergency Medical Practice",
                "description": "The internship phase provides students with immersive exposure to real-world emergency and critical care environments, enabling them to apply the knowledge and skills acquired throughout the programme. Working alongside healthcare professionals across emergency departments, ambulances, intensive care units, and other clinical settings, students gain practical experience in patient assessment, emergency interventions, critical decision-making, and interdisciplinary collaboration. This hands-on training helps strengthen professional competence, clinical confidence, and preparedness for a career in emergency medical services and pre-hospital care.",
                "subjects": [
                    { "name": "Internship – I", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" },
                    { "name": "Internship – II", "bgColor": "bg-[#FFE5CC]", "textColor": "text-[#CC6600]" }
                ]
            },
            {
                name: "Value Addition",
                title: "Value-Added Learning Opportunities",
                description: "Students gain access to skill certifications, semester-wise workshops, and industry visits that enhance practical learning and professional development. Additionally, aspiring entrepreneurs can explore venture creation opportunities with mentorship, incubation support, and access to funding through the Medhavi NextGen Innovation and Incubation Center and government-backed initiatives.",
                "keySubjectsLabel": "Key Features",
                subjects: [
                    { "name": "Skill certifications", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" },
                    { "name": "One workshop per semester", "bgColor": "bg-[#FFE5CC]", "textColor": "text-[#CC6600]" },
                    { "name": "One industry visit per semester", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" },
                    { "name": "Opportunity for venture creation through university and government funding (Medhavi NextGen Innovation and Incubation Center)", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" }
                ],
                "learningOutcomes": [
                    "Gain real-world experience through the Red.Health Network internship",
                    "Execute industry-based projects in healthcare settings",
                    "Complete a capstone project and dissertation",
                    "Transition confidently into healthcare management roles",
                    "Prepare professionally through CV launch and career readiness activities"
                ]
            }
        ]
    },

    faq: {
        id: 102,
        title: "Bachelors of Emergency Medical Technologist (Paramedic)",
        FAQ: [
            {
                "id": 1,
                "Question": "What is the university's role and what is Emversity's role?",
                "Answer": "MSU manages all academic matters — admissions, examinations, marksheets, transcripts, and degree conferral. All fees are payable directly to the university. Emversity is the industry-skilling partner and delivers AR/VR simulation training, industry-co-designed skill modules, clinical internship facilitation, placement assistance, and the Cambridge English program. Emversity does not collect fees, conduct exams, or award degrees."
            },
            {
                "id": 2,
                "Question": "Is placement or internship stipend guaranteed?",
                "Answer": "Emversity provides placement assistance through its network of 500+ healthcare employer partners and facilitates structured clinical internships. However, placement is not guaranteed and stipend amounts vary by employer. Final hiring and stipend decisions rest with the host institution."
            },
            {
                "id": 3,
                "Question": "Is this program recognised, and is it full-time?",
                "Answer": "Yes, this is a full-time, on-campus program. MSU is established under the Medhavi Skills University, Sikkim Act, 2021 and is recognised by the UGC under Section 2(f). The curriculum is aligned with the NCAHP Act 2021 framework. Students should verify current NCAHP notifications and state council registration requirements directly with the university."
            },
            {
                "id": 4,
                "Question": "How do I apply?",
                "Answer": "Applications are submitted through MSU's official admissions portal. Candidates may be required to appear for the Medhavi Scholarship & Aptitude Test (MSAT). For eligibility verification, fee details, and application deadlines, please contact the MSU admissions office directly."
            },
            {
                "id": 5,
                "Question": "What is the Head Start Programme?",
                "Answer": "The Head Start Programme is a zero-cost, online bridge course offered before classes begin. It covers foundational concepts and essential skills for your chosen field. Participation is voluntary, non-credit-bearing, and does not affect admission status or academic standing. Students who successfully complete it receive a complimentary laptop and may be eligible for additional scholarships."
            },
            {
                "id": 6,
                "Question": "Is this programme NCAHP aligned?",
                "Answer": "Yes. The curriculum is subject to periodic revision by MSU in alignment with NCAHP guidelines and evolving industry requirements. Students should refer to the university's official academic notifications for the latest syllabus."
            },
            {
                "id": 7,
                "Question": "Is this course UGC recognised?",
                "Answer": "Yes, MSU is recognised by the UGC under Section 2(f) and this programme is offered as a full-time, on-campus undergraduate degree."
            }
        ]
    },
    coursePrice: { price: "₹8,00,000" }
};